import request from '@/utils/request'

let UserApi = {

    /*用户登录*/
    login(data, errorback) {
        return request._post('/shop/passport/login', data, errorback);
    },
    /*退出登录*/
    loginOut(data, errorback) {
        return request._post('/shop/passport/logout', data, errorback);
    },
    /*添加用户*/
    adduser(data, errorback) {
        return request._post('/shop/user.user/add', data, errorback);
    },

    // fzf
    /*修改用户*/
    edituser(data, errorback) {
        return request._post('/shop/user.user/edit', data, errorback);
    },
    /*修改用户上级*/
    edituseragent(data, errorback) {
        return request._post('/shop/user.user/editUserAgent', data, errorback);
    },
    /*修改用户等级*/
    edituserlevel(data, errorback) {
        return request._post('/shop/user.user/editUserLevel', data, errorback);
    },
    /*修改用户礼包*/
    edituserpg(data, errorback) {
        return request._post('/shop/user.user/editUserPg', data, errorback);
    },
    /*修改课程礼包*/
    editusercourse(data, errorback) {
        return request._post('/shop/user.user/editUserCourse', data, errorback);
    },



     /*修改代理老板*/
     editAgent(data, errorback) {
        return request._post('/shop/user.user/editAgent', data, errorback);
    },
    /*充值*/
    userRecharge(data, errorback) {
        return request._post('/shop/user.user/recharge', data, errorback);
    },
    /*删除用户*/
    deleteuser(data, errorback) {
        return request._post('/shop/user.user/delete', data, errorback);
    },
    // 修改上级
    changeReferee(data, errorback) {
        return request._post('/shop/user.user/changeReferee', data, errorback);
    },


    /*用户列表*/
    userlist(data, errorback) {
        return request._post('/shop/user.user/index', data, errorback);
    },
    /*等级列表*/
    gradelist(data, errorback) {
        return request._post('/shop/user.grade/index', data, errorback);
    },
    /*添加等级*/
    addgrade(data, errorback) {
        return request._post('/shop/user.grade/add', data, errorback);
    },
    /*修改等级*/
    editGrade(data, errorback) {
        return request._post('/shop/user.grade/edit', data, errorback);
    },
    /*删除等级*/
    deletegrade(data, errorback) {
        return request._post('/shop/user.grade/delete', data, errorback);
    },
    /*会员升级记录*/
    gradeLog(data, errorback) {
        return request._get('/shop/user.grade/log', data, errorback);
    },
    /*用户余额*/
    BalanceLog(data, errorback) {
        return request._post('/shop/user.Balance/log', data, errorback);
    },
    /*充值记录*/
    RechargeOrder(data, errorback) {
        return request._post('/shop/user.Recharge/order', data, errorback);
    },
    /*修改密码*/
    EditPass(data, errorback) {
        return request._post('/shop/passport/editPass', data, errorback);
    },
    /*用户等级*/
    structureGrade(data, errorback) {
        return request._post('/shop/user.Structure/grade', data, errorback);
    },
    /*用户结构*/
    structureList(data, errorback) {
        return request._post('/shop/user.Structure/user', data, errorback);
    },
    /*佣金记录*/
    AgentLog(data, errorback) {
        return request._post('/shop/user.agent_log/index', data, errorback);
    },
     /* 积分区域记录*/
     RegionLog(data, errorback) {
        return request._post('/shop/user.agent_log/regionlog', data, errorback);
    },
    /*佣金记录*/
    AgentCapital(data, errorback) {
        return request._post('/shop/user.agent_log/agentCapital', data, errorback);
    },
    /*代理老板*/
    agentboss(data, errorback) {
        return request._post('/shop/user.agent/boss', data, errorback);
    },
    /*培养业绩*/
    ProfitsLog(data, errorback) {
        return request._get('/shop/user.user/profits', data, errorback);
    },
    editProfits(data, errorback) {
        return request._post('/shop/user.user/editprofits', data, errorback);
    },
    sendProfits(data, errorback) {
        return request._post('/shop/user.user/sendprofits', data, errorback);
    },
    // 业绩明细
    getPfofitsLog(data, errorback) {
        return request._get('/shop/user.user/profitslog', data, errorback);
    },
}

export default UserApi;



// WEBPACK FOOTER //
// ./src/api/user.js